import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/components/ui/select';
import { SortDescIcon } from 'lucide-react';
export interface SortingProps {
  sortBy?: string;
  // placeholder: string;
  className?: string;
  onChange: (rating: string) => void;
  disabled: boolean;
}

export function Sorting({
  sortBy,
  // placeholder = 'Todas las ciudades',
  className,
  onChange,
  disabled,
}: SortingProps) {

  const handleChange = (sortingBy: string) => {
    // "all" means clear filter
    if (sortingBy === 'all') {
      onChange('all')
    } else {
      onChange(sortingBy)
    }
  }

  return (
    <div className={`relative ${className}`} >
      <SortDescIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none z-10" />

      <Select
        value={sortBy}
        onValueChange={handleChange}
        disabled={disabled}
      >
        <SelectTrigger className="pl-10">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="rating-desc">Mayor calificación</SelectItem>
          <SelectItem value="rating-asc">Menor calificación</SelectItem>
          <SelectItem value="reviews-desc">Más reseñas</SelectItem>
          <SelectItem value="reviews-asc">Menos reseñas</SelectItem>
          <SelectItem value="name-asc">Nombre (A-Z)</SelectItem>
          <SelectItem value="name-desc">Nombre (Z-A)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}